import { render, staticRenderFns } from "./CurrentLpo__resultTable2.vue?vue&type=template&id=61e467d9&scoped=true&"
import script from "./CurrentLpo__resultTable2.vue?vue&type=script&lang=js&"
export * from "./CurrentLpo__resultTable2.vue?vue&type=script&lang=js&"
import style0 from "@/style/tables.scss?vue&type=style&index=0&id=61e467d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e467d9",
  null
  
)

export default component.exports